import * as React from 'react';

import AboutYou from '../AboutYou';
import Button from '../../components/buttons/Button';
import { IconChevronRight } from '../../components/icons';
import WorkflowStep from '../WorkflowStep';
import Fieldset from '../../components/forms/Fieldset';
import { InputError, Validation } from '../../common/utils';

interface Props {
	user: UserDetails;
	currentUser: UserDetails;
	customerDetails: CustomerDemographicDetails;
	onUserChange: (e: any) => void;
	onCustomerDetailsChange: (e: any) => void;
	history: any;
	match: any;
}
class SimpleAboutYouPage extends React.Component<Props> {
	errors = { age: {} as InputError };

	validate = () => {
		// true means invalid
		return {
			age: Validation.validateAge(this.props.user.birthDate, this.props.currentUser.isAuthenticated)
		};
	}

	isNextDisabled = () => {
		if (this.props.customerDetails.age == null
			|| this.props.user.gender == null
			|| this.props.customerDetails.isSmoker == null) {
			return true;
		}

		return this.errors.age.hasError;
	}

	next = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/select-your-policy`);
	}

	render() {
		this.errors = this.validate();
		return (
			<WorkflowStep title="Before we begin, we'd like to get to know you better.">
				<Fieldset>
					<AboutYou {...this.props} errors={this.errors} />
				</Fieldset>
				<div className="workflow-progress-actions">
					<Button
						onClick={this.next}
						className="btn-primary"
						disabled={this.isNextDisabled()}
					>
						<span className="align-middle mx-2">Select your policy</span>
						<IconChevronRight />
					</Button>
				</div>
			</WorkflowStep>
		);
	}
}

export default SimpleAboutYouPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/simple/SimpleAboutYouPage.tsx